import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=aaa1510c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa1510c"]])

export default __exports__